import React from 'react';
import { Header } from './components/Header';
import { Navigation } from './components/Navigation';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Services } from './components/Services';
import { WhyChooseUs } from './components/WhyChooseUs';
import { CallToAction } from './components/CallToAction';
export function App() {
  return <div className="w-full min-h-screen bg-white" data-id="element-0">
      <Header data-id="element-1" />
      <Navigation data-id="element-2" />
      <Hero data-id="element-3" />
      <Services data-id="element-4" />
      <About data-id="element-5" />
      <WhyChooseUs data-id="element-6" />
      <CallToAction data-id="element-7" />
    </div>;
}